import _omit from 'lodash/omit';

import {
  ACTION_CANCEL_SITE_ARTICLE__REQUEST,
  ACTION_CANCEL_SITE_ARTICLE__SUCCESS,
  ACTION_CANCEL_SITE_ARTICLE__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_CANCEL_SITE_ARTICLE__REQUEST:
    case ACTION_CANCEL_SITE_ARTICLE__SUCCESS:
      return null;

    case ACTION_CANCEL_SITE_ARTICLE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
